import { render, staticRenderFns } from "./BiCompairBoxGoogle.vue?vue&type=template&id=5c6872af&"
import script from "./BiCompairBoxGoogle.vue?vue&type=script&lang=js&"
export * from "./BiCompairBoxGoogle.vue?vue&type=script&lang=js&"
import style0 from "./BiCompairBoxGoogle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports